import { render, staticRenderFns } from "./CoursesCrud.vue?vue&type=template&id=2703c3e4"
import script from "./CoursesCrud.vue?vue&type=script&lang=js"
export * from "./CoursesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports